import { useClientStore } from "../stores/client";
import { withErrorHandling } from "../utils/errors";

type HttpMethod = 'POST' | 'GET' | 'PUT' | 'PATCH' | 'DELETE';

interface Props<Payload = unknown> {
  defaultErrorMessage?: string;
  endpoint: string | ((payload: Payload) => string);
  method?: HttpMethod;
}

const useGetMutationFn = <Payload = unknown, Response = unknown>(
  props: Props<Payload>
) => {
  const {
    defaultErrorMessage = 'An unexpected error occurred',
    endpoint,
    method = 'POST',
  } = props;

  const request = useClientStore((state) => state.request);

  const mutationFn = withErrorHandling(
    async (payload: Payload): Promise<Response> => {
      const resolvedEndpoint =
        typeof endpoint === 'function'
          ? endpoint(payload)
          : endpoint;

      const response = await request<Response>(
        resolvedEndpoint,
        method,
        payload
      );

      return response;
    },
    defaultErrorMessage,
  );

  return mutationFn;
};

export default useGetMutationFn;